/* eslint-disable @typescript-eslint/no-explicit-any -- disabled as we want to follow the codebase of MUI */
import type { GridFilterOperator } from '@mui/x-data-grid-pro';
import dayjs from 'dayjs';

import { GridFilterInputDateRange } from '../../panel/filter-panel/grid-filter-input-date-range';

type GridDateRangeOperator = GridFilterOperator<any, dayjs.ConfigType, any>;

const isBetweenOperator: GridDateRangeOperator = {
  label: 'is between',
  value: 'isBetween',
  getApplyFilterFn: ({ value }) => {
    if (
      !Array.isArray(value) ||
      value.length !== 2 ||
      value.some((v) => v == null)
    ) {
      return null;
    }
    return (cellValue): boolean => {
      const dayValue = dayjs(cellValue);
      return value[0].isBefore(dayValue) && value[1].isAfter(dayValue);
    };
  },
  InputComponent: GridFilterInputDateRange,
};

export const getGridDateRangeOperators = (): GridDateRangeOperator[] => [
  isBetweenOperator,
];
